<template>
    <div class="book" @click="direct" :style="{ width: width + 'px', height: height + 'px' }">
        <img class="cover" :src="cover"/>
        <div class="page" v-for="i in 6" :key="i" :style="{ top: i + 'px', left: i + 'px', right: -i + 'px', bottom: i + 'px', zIndex: 10 - i }"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        name: {
            default: '',
        },
        cover: {
            default: '',
        },
        width: {
            default: 80,
        },
        height: {
            default: 120,
        }
    },
    methods: {
        direct() {
            if (this.name) {
                this.$emit('read', this.name);
            }
        }
    }
}
</script>

<style lang="less" scoped>
.book {
    display: inline-block;
    position: relative;

    .cover {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        width: 100%;
        height: 100%;
    }

    .page {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: white;
        border: 1px solid #ddd;
    }
}
</style>
